import { render } from "./rewards.vue?vue&type=template&id=3a3cd79c&scoped=true"
import script from "./rewards.js?vue&type=script&lang=js&external"
export * from "./rewards.js?vue&type=script&lang=js&external"

import "./rewards.vue?vue&type=style&index=0&id=3a3cd79c&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a3cd79c"]])

export default __exports__